import { CSSProperties, FunctionComponent, PropsWithChildren } from "react";
import * as Styled from "./styles";

interface FlexProps extends PropsWithChildren {
  $flexDirection?: CSSProperties["flexDirection"];
  $justifyContent?: CSSProperties["justifyContent"];
  $width?: string;
  $height?: string;
  $alignItems?: CSSProperties["alignItems"];
  $flexGap?: CSSProperties["gap"];
  className?: string;
  $marginTop?: CSSProperties["marginTop"];
  $marginBottom?: CSSProperties["marginBottom"];
}

const Flex: FunctionComponent<FlexProps> = (props: FlexProps) => {
  return <Styled.FlexDiv {...props}>{props.children}</Styled.FlexDiv>;
};

export default Flex;
